/**
 * APITable <https://github.com/apitable/apitable>
 * Copyright (C) 2022 APITable Ltd. <https://apitable.com>
 *
 * This program is free software: you can redistribute it and/or modify
 * it under the terms of the GNU Affero General Public License as published by
 * the Free Software Foundation, either version 3 of the License, or
 * (at your option) any later version.
 *
 * This program is distributed in the hope that it will be useful,
 * but WITHOUT ANY WARRANTY; without even the implied warranty of
 * MERCHANTABILITY or FITNESS FOR A PARTICULAR PURPOSE.  See the
 * GNU Affero General Public License for more details.
 *
 * You should have received a copy of the GNU Affero General Public License
 * along with this program.  If not, see <http://www.gnu.org/licenses/>.
 */

import { get, cloneDeep } from 'lodash';

export const EMPTY_CONTENT = [
  {
    type: 'paragraph',
    children: [
      {
        text:''
      },
    ],
  },
];

export const draft2slate = (content: any) => {
  if (get(content, 'blocks')) {
    const { blocks, entityMap } = content;
    const result: object[]= [];
    for (const block of blocks) {
      const { text, entityRanges } = block;
      const res:{type: string; children: object[]} = {
        type: 'paragraph',
        children: []
      };
      if (entityRanges && entityRanges.length) {
        let start = 0;
        for (const entityRange of entityRanges) {
          const { offset, length, key } = entityRange;
          res.children.push({ text: text.slice(start, offset) });

          res.children.push({
            data: entityMap[key].data.mention,
            type: 'mention',
            children: [{ text: '' }],
          });
          start = offset + length;
        }
        res.children.push({ text: text.slice(start) });
      } else {
        res.children.push({ text });
      }
      result.push(res);
      result.push(cloneDeep(EMPTY_CONTENT[0]));
    }
    return result;
  }
  return content || EMPTY_CONTENT;
};
